import { isMobile } from '@Constants/LeftDrawer';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';

import BrandDetails from './Components/BrandDetails';
import Header from './Components/Header';
import { SeenThingsAnimatedWrapper } from './Components/SeenThingsAnimationWrapper';
import SeenThingsByBrand from './Components/SeenThingsByBrand';
import SeenThingsByDate from './Components/SeenThingsByDate';
import { useSeenThingsPresenter } from './SeenThingsPresenter';

const StyledNavigationAccordionWrapper = styled.View<{
  height?: number;
  accordionWidth?: number | string;
  grow?: boolean;
  thin?: boolean;
}>`
  width: 100%;
  height: calc(100vh - ${isMobile ? '86' : '100'}px);
  position: relative;
  overflow: hidden;
  background-color: white;
  border-radius: 30px;
  pointer-events: all;
`;

export const StyledAnimationsWrapper = styled.View<{ active: boolean }>`
  width: 100%;
  padding: ${isMobile ? '18px 35px' : '60px'};
  pointer-events: ${(active) => (active ? 'inherit' : 'none')};
`;

export const StyledCardContent = styled.View`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${isMobile ? 17.6 : 30}px;
`;

const SeenThings: FC = () => {
  const { mode, brandAnimation, detailAnimation } = useSeenThingsPresenter();

  return (
    <StyledNavigationAccordionWrapper>
      <Header />
      {mode.value === 'brand' && (
        <ScrollView>
          <SeenThingsAnimatedWrapper type='brand'>
            <StyledAnimationsWrapper active={brandAnimation.value}>
              <SeenThingsByBrand />
            </StyledAnimationsWrapper>
          </SeenThingsAnimatedWrapper>

          <SeenThingsAnimatedWrapper type='detail'>
            <StyledAnimationsWrapper active={detailAnimation.value}>
              <BrandDetails />
            </StyledAnimationsWrapper>
          </SeenThingsAnimatedWrapper>
        </ScrollView>
      )}

      {mode.value === 'date' && <SeenThingsByDate />}
    </StyledNavigationAccordionWrapper>
  );
};

export default observer(SeenThings);
